import LogComponent from './components/LogComponent';
import LogStore from './stores/LogStore';

module.exports = {
  Component: LogComponent,
  LogStore,
};



// WEBPACK FOOTER //
// ./comMobx/wea-log-view/index.js